import React, { useState } from "react";
import { syllabusGroups } from "../data/barCouncilSyllabus";

export default function SyllabusOverview() {
  const [openGroup, setOpenGroup] = useState(null);

  return (
    <div style={{ padding: "0 10px" }}>
      {syllabusGroups.map((group) => (
        <div
          key={group.id}
          style={{
            marginBottom: "10px",
            border: "1px solid #ddd",
            background: "#f8f8f8",
            borderRadius: "4px",
          }}
        >
          {/* HEADER */}
          <div
            onClick={() => setOpenGroup(openGroup === group.id ? null : group.id)}
            style={{
              padding: "12px",
              fontSize: "18px",
              color: "green",
              cursor: "pointer",
              fontWeight: "500",
            }}
          >
            {group.title}
          </div>

          {/* BODY */}
          {openGroup === group.id && (
            <div style={{ padding: "12px 20px", background: "white" }}>
              {group.items.map((item, i) => (
                <div
                  key={i}
                  style={{
                    marginBottom: "6px",
                    fontSize: "16px",
                    lineHeight: "1.4",
                  }}
                >
                  {item}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
